import React from 'react';
import { trans } from '../localization/language';

export default class FAQ extends React.Component {
	render() {
		return (
			<div className="main">
				<div className="faq">
					<div className="faq_item">
						<div className="faq_q">
							<div className="faq_q_start">Q:</div>
							<div className="faq_q_content">{trans('faq_q1')}</div>
						</div>
						<div className="faq_a">
							<div className="faq_a_start">A:</div>
							<ol className="faq_a_content">
								<li>{trans('faq_q1_a')}</li>
								<li>1. {trans('faq_q1_a1')}</li>
								<li>2. {trans('faq_q1_a2')}</li>
								<li>3. {trans('faq_q1_a3')}</li>
								<li>4. {trans('faq_q1_a4')}</li>
								<li className="last_li">5. {trans('faq_q1_a5')}</li>
							</ol>
						</div>
					</div>
					<div className="faq_item_separator"></div>
					<div className="faq_item">
						<div className="faq_q">
							<div className="faq_q_start">Q:</div>
							<div className="faq_q_content">{trans('faq_q2')}</div>
						</div>
						<div className="faq_a">
							<div className="faq_a_start">A:</div>
							<ol className="faq_a_content">
								<li className="last_li">{trans('faq_q2_a')}</li>
							</ol>
						</div>
					</div>
					<div className="faq_item_separator"></div>
					<div className="faq_item">
						<div className="faq_q">
							<div className="faq_q_start">Q:</div>
							<div className="faq_q_content">{trans('faq_q3')}</div>
						</div>
						<div className="faq_a">
							<div className="faq_a_start">A:</div>
							<ol className="faq_a_content">
								<li className="last_li">{trans('faq_q3_a')}</li>
							</ol>
						</div>
					</div>
					<div className="faq_item_separator"></div>
					<div className="faq_item">
						<div className="faq_q">
							<div className="faq_q_start">Q:</div>
							<div className="faq_q_content">{trans('faq_q4')}</div>
						</div>
						<div className="faq_a">
							<div className="faq_a_start">A:</div>
							<ol className="faq_a_content">
								<li className="last_li">{trans('faq_q4_a')}</li>
							</ol>
						</div>
					</div>
					<div className="faq_item_separator"></div>
					<div className="faq_item">
						<div className="faq_q">
							<div className="faq_q_start">Q:</div>
							<div className="faq_q_content">{trans('faq_q5')}</div>
						</div>
						<div className="faq_a">
							<div className="faq_a_start">A:</div>
							<ol className="faq_a_content">
								<li className="last_li">{trans('faq_q5_a')}</li>
							</ol>
						</div>
					</div>
					<div className="faq_item_separator"></div>
					<div className="faq_item">
						<div className="faq_q">
							<div className="faq_q_start">Q:</div>
							<div className="faq_q_content">{trans('faq_q6')}</div>
						</div>
						<div className="faq_a">
							<div className="faq_a_start">A:</div>
							<ol className="faq_a_content">
								<li className="last_li">{trans('faq_q6_a')}</li>
							</ol>
						</div>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./app/components/FAQ.js